import React from "react";
import { ThemeProvider, StyledEngineProvider } from "@mui/material/styles";
import { theme } from "./utils/theme";

import { ACRMonitor } from "./ACRMonitor";
import "./App.css";
import { acrAPI } from "./utils/api";
import { loginService } from "utils/login";


export class APP extends React.Component {
  constructor(props: any) {
    super(props);
    acrAPI.init();
    acrAPI.getVersion();
    loginService.init();
  }

  public render(): JSX.Element {
    return (
      <StyledEngineProvider injectFirst>
        <ThemeProvider theme={theme}>
          <ACRMonitor />
        </ThemeProvider>
      </StyledEngineProvider>
    );
  }
}

export default APP;
